module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-专区.5f202.png";